import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import backIcon from "assets/images/back-icon.svg";
import { Loader } from "react-feather";
import { ClipLoader } from "react-spinners";

export default function HealthAnalyseHeader({
  headline,
  subHeadline,
  handleNextPage,
  btnText = "Weiter",
  handleBack,
  noBackButton = false,
  loading = false,
}) {
  return (
    <Container>
      <div className="step-header">
        <div className="header-content">
          {!noBackButton && (
            <Link
              onClick={handleBack}
              style={{
                ...(headline ? {} : { marginTop: 10 }),
              }}
            >
              <img src={backIcon} alt="back icon" />
            </Link>
          )}
          <div className="headline-gap">
            <div className="headline">{headline}</div>
            <h3 className="sub-headline">{subHeadline}</h3>
          </div>
        </div>
        {!loading ? (
          <div className="actions">
            <span onClick={handleNextPage} className="btn-dark-header">
              {btnText}
            </span>
          </div>
        ) : (
          <ClipLoader />
        )}
      </div>
    </Container>
  );
}

const Container = styled.div`
  .header-content {
    @media screen and (max-width: 768px) {
      a {
        display: none;
      }
    }
    @media screen and (min-width: 768px) {
      display: flex;
      gap: 20px;
    }
  }
  .actions {
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .step-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e2e4e9;
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      @media screen and (max-width: 768px) {
        display: none;
      }
    }
    .headline-gap {
      display: flex;
      flex-direction: column;
      gap: 5px !important;
    }
    .headline {
      color: #1c9d87;
      font-weight: bold;
    }

    .sub-headline {
      color: #142c1f;
      font-size: 20px;
    }

    .main-button {
      border: none;
      cursor: pointer;
      background: linear-gradient(110deg, #2ecf96 0%, #1c9d87 100%);
      background-size: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-radius: 10px;
      font-weight: 600;
      width: max-content;
      transition: all 0.2s ease-in-out;
      padding: 5px 40px;
    }

    .main-button:hover {
      background: linear-gradient(110deg, #2ecf96 0%, #1c9d87 100%);
      background-size: 150%;
      transform: translateY(-2px);
    }
    .btn-dark-header {
      background: linear-gradient(180deg, #47584f 0%, #596860 100%);
      // background: linear-gradient(180deg, #ffffff1f 0%, #ffffff00 100%);

      border-radius: 10px;
      padding: 8px 30px;
      width: max-content;
      color: white;
      border: none;
      display: flex;
      align-items: center;
      gap: 8px;
      justify-content: center;
      cursor: pointer;
      text-decoration: none;
      font-family: "RubikMedium";
      font-size: 14px !important;
      transition: all 0.3s ease-in-out;
      border: 1px solid #1c9d87;
      /* font-weight: 600; */
      font-size: 16px;

      &:hover {
        box-shadow: 4px 4px 0px #2ecf96;
        // background: linear-gradient(180deg, #2ecf96 0%, #2ecf96 100%);
      }

      &.w-max {
        width: 100%;
        max-width: 217px;
      }
    }
  }
`;
